import { useTheme } from 'tamagui'
import { withAlpha } from '../theme/color'
import { SemanticColorKey, semanticFromPalette } from '../theme/semantic'
import { dark } from '../theme/dark'

const fallback = semanticFromPalette(dark)

/**
 * Valor cru de um token semântico do tema ativo, para APIs que não resolvem
 * token do Tamagui (LinearGradient, ActivityIndicator, RenderHtml, style do RN).
 * Com `alpha`, devolve a mesma cor em rgba (fades de gradiente sobre o fundo).
 */
export function useThemeColor(key: SemanticColorKey, alpha?: number): string {
  const theme = useTheme()
  const value = theme[key]?.val
  const color = typeof value === 'string' ? value : fallback[key]

  return alpha === undefined ? color : withAlpha(color, alpha)
}
